import { gql } from "@apollo/client";

export const TERMS = gql`
  query getTerms {
    getTerms {
      terms {
        text,
        type,
        url,
        content {
          id,
          title,
          version,
          items {
            subtitle,
            paragraphs,
          },
        },
      },
      success,
      messages,
    }
  }
`;
